import {useTranslation} from "react-i18next";
import React, {useEffect, useState} from "react";
import associateServices from "../../services";
import {toast} from "react-toastify";
import SvgIcon from "../svg-icon";
import FormButton from "../form-button";

const TableFooterCampaign = props => {

    const {page, total, limit, handleNext, handlePrev, section = null, handleCreate} = props
    const {t} = useTranslation()

    const [prevAble, setPrevAble] = useState(true)
    const [nextAble, setNextAble] = useState(true)
    useEffect(() => {
        setPrevAble(page >= 2)
        setNextAble(parseInt(page * limit) < total)
    }, [page, total, limit])

    const [requesting, setRequesting] = useState(false)
    const onRequest = () => {
        setRequesting(true)
        associateServices.requestDownload({
            model: section
        }).then(res => {
            setRequesting(false)

            return toast.info(t(`api-notifications.${res?.data || res?.errors}`))
        })
    }

    return (
        <div className="table-wrap__cellar">
            <div className="table-wrap__nav">
                <button
                    className="table-wrap__btn table-wrap__btn--prev"
                    onClick={handlePrev}
                    disabled={!prevAble}
                    type="button"
                >
                    <SvgIcon id={'arrow-left-long'}/>
                    {t('general.prev_page')}
                </button>
                {/*<span>{page}</span>*/}
                <button
                    disabled={!nextAble}
                    className="table-wrap__btn table-wrap__btn--next"
                    onClick={handleNext}
                    type="button"
                >
                    {t('general.next_page')}
                    <SvgIcon id={'arrow-right-long'}/>
                </button>
            </div>

            <FormButton
                onClick={handleCreate}
                isSmall={true}
                loading={false}
                disabled={false}
                label={t('affiliate.campaigns.create-campaign')}
            />


        </div>
    )
}

export default TableFooterCampaign
